/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Vo_CompleteInputs */

const en_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO Track complete...`)
};

const fr_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piste VO terminée...`)
};

const de_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO-Spur abgeschlossen...`)
};

const it_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traccia VO completata...`)
};

const ru_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись озвучки завершена...`)
};

const es_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pista VO completa...`)
};

const zh_cn2_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配音轨道已完成……`)
};

const ja_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VOトラックが完了しました...`)
};

const hi_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वॉयस ओवर ट्रैक पूरा हो गया...`)
};

const pt_pt2_audio_description_export_status_vo_complete = /** @type {(inputs: Audio_Description_Export_Status_Vo_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faixa de narração concluída...`)
};

/**
* | output |
* | --- |
* | "VO Track complete..." |
*
* @param {Audio_Description_Export_Status_Vo_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_vo_complete = /** @type {((inputs?: Audio_Description_Export_Status_Vo_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Vo_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_vo_complete(inputs)
	if (locale === "de") return de_audio_description_export_status_vo_complete(inputs)
	if (locale === "it") return it_audio_description_export_status_vo_complete(inputs)
	if (locale === "ru") return ru_audio_description_export_status_vo_complete(inputs)
	if (locale === "es") return es_audio_description_export_status_vo_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_vo_complete(inputs)
	if (locale === "ja") return ja_audio_description_export_status_vo_complete(inputs)
	if (locale === "hi") return hi_audio_description_export_status_vo_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_vo_complete(inputs)
	return en_audio_description_export_status_vo_complete(inputs)
});